import { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal, message } from 'antd'
import MyInput from '../../../components/forms/input'
import MyTextArea from '../../../components/forms/textArea'

const EditExerciseRecipe = (props) => {
  const { item } = props.data
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})

  useEffect(() => {
    setFormValue(item)
  }, [item])

  const handleOk = () => {
    setErrorMsg({})
    if (!formValue.name) {
      setErrorMsg({nameEmpty: '食谱名称不能为空'})
      return false
    }

    axios.post('/admin/user/exercise_recipe/edit', { 
      recipe_oid: formValue.oid,
      name: formValue.name,
      goal: formValue.goal
    })
      .then(function (response) {
        if (response.errcode === 0) {
          handleCancel()
          props.getExerciseRecipeData()
          message.success('修改成功！')
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleCancel = () => {
    setErrorMsg({})
    props.isCancel()
  }

  return (
    <Modal 
      title='编辑运动食谱'
      destroyOnClose={true}
      width='800px'
      open={props.isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      cancelText="取消"
      okText="保存">

      <MyInput
        id="name"
        required
        autoFocus
        maxLength={64}
        label='食谱名称'
        placeholder='请输入食谱名称'
        value={formValue.name}
        onChange={setFormValue}
        errorMsg={errorMsg.nameEmpty}
      />

      <MyTextArea
        id="goal"
        label='食谱目标'
        minRows={3}
        placeholder='请输入食谱目标'
        value={formValue.goal}
        onChange={setFormValue}
      />

      <MyInput
        type='number'
        id="sort"
        label='排序'
        value={formValue.sort}
        onChange={setFormValue}
        styles={{ width: '60px' }}
        min={0}
        max={1000}
      />
    </Modal>
  )
}

export default EditExerciseRecipe
